<ul class="p-0 m-0" id="detail_zuganginfo">
  @if (termin.angebot.zugang) {
    <li class="d-flex flex-column mb-1">
      <span id="detail_zugang_label" class="fw-bold">Zugangsvoraussetzungen</span>
      <span
        id="detail_zugang"
        class="keywords"
        [innerHTML]="sanitizeFunction(termin.angebot.zugang)"
      ></span>
    </li>
  }

  @if (termin.angebot.anrechnung) {
    <li class="d-flex flex-column mb-1">
      <span id="detail_anrechnung_label" class="fw-bold">Anrechnung</span>
      <span
        id="detail_anrechnung"
        class="keywords"
        [innerHTML]="sanitizeFunction(termin.angebot.anrechnung)"
      ></span>
    </li>
  }

  @if (termin.angebot.zielgruppe) {
    <li class="d-flex flex-column mb-1">
      <span id="detail_zielgruppe_label" class="fw-bold">Zielgruppe</span>
      <span
        id="detail_zielgruppe"
        class="keywords"
        [innerHTML]="sanitizeFunction(termin.angebot.zielgruppe)"
      ></span>
    </li>
  }

  <li class="d-flex flex-column mb-1">
    <span id="detail_teilnehmerzahl_label" class="fw-bold">Teilnehmerzahl</span>
    <span id="detail_teilnehmerzahl">{{ computeTeilnehmer() }}</span>
  </li>

  @if (termin.angebot.behinderungen?.length! > 0) {
    <li class="d-flex flex-column mb-1">
      <span id="detail_behinderungen_label" class="fw-bold"
        >Maßnahme geeignet für Teilnehmer mit folgenden gesundheitlichen Beeinträchtigungen</span
      >
      <span id="detail_behinderungen">
        @for (behinderung of termin.angebot.behinderungen; track behinderung.id) {
          <div>{{ behinderung.bezeichnung }}</div>
        }
      </span>
    </li>
  }
</ul>
